import { MatDialogConfig } from '@angular/material/dialog';

export class ModalConfig{
    // dialogConfig = new MatDialogConfig();

    disableClose: boolean;
    actions: boolean;
    id: string;
    height: string;
    width: string;
    data: {};
    maxHeight: string;

    constructor(configData){
          // The user can't close the dialog by clicking outside its body

        this.disableClose = true;
        this.id = "modal-component";
        this.height = "30%";
        this.width = "40%";
        if(screen.width < 576){
            this.width = "80%";
            this.height = "35%";
        }
        else if(screen.width < 768){
            this.width = "80%";
            this.height = "30%";
        }
        else if(screen.width < 992){
            this.width = "60%";
            this.height = "25%";
        }
        else if(screen.width < 1200){
            this.width = "50%";
            this.height = "20%";
        }
        this.data = configData;
        if(configData.modalForm || configData.style){
            this.maxHeight = configData.style ? configData.style.maxHeight: "70vh";
            this.width = configData.style ? configData.style.width : "60%";
            this.height = configData.style ?configData.style.height : "auto";
            if(screen.width < 768){
                this.width = "80%";
                this.height = "70%";
            }
        }
    }
}
